
// update state
const setActionsWindowPopup = (payload) => {
    return {
        type: "ACTIONWINDOWPOPUP",
        payload
    }
}

export default setActionsWindowPopup;


// WEBPACK FOOTER //
// ./src/actions/setActionsWindowPopup.js